import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanSuggestionInfo, AccountTrialStatus, AccountTierFields, AccountRoleInfo, AccountManagedByAdobe, AccountOwner, SubscriptionInfo, AccountLockingInfo, AccountPlanAndTrialInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountUsageQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountUsageQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, delinquentGracePeriodExpiresAt?: string | null, managedBy?: Types.AccountManagementTypes | null, lockedAt?: string | null, lockReason?: Types.LockReason | null, owner?: { __typename?: 'Owner', id: string, name: string, email: string } | null, subscription: { __typename?: 'AccountSubscription', discountOfferExpiresAt?: string | null, id: string, cancelledAt?: string | null, isLegacy?: boolean | null, cost?: number | null, nextBillAt?: string | null, pauseOfferExpiresAt?: string | null, period: Types.SubscriptionPeriod, subscriptionEndAt?: string | null, tier: Types.AccountTier, title: string, balance: number, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, paymentMethod: Types.PlanPaymentMethod, period: Types.PlanPeriod, tier: Types.PlanTier, version?: number | null, activeStorageLimit?: number | null, archivedStorageLimit?: number | null, title: string, eligibility: Types.PlanEligibility, mountedStorageLimit?: number | null, userLimit?: number | null, userMax?: number | null, perUserStorageIncrement?: number | null, availableFeatures: { __typename?: 'AvailableFeatures', id: string, mountedStorage: boolean, mountedStorageOverprovisioningAllowed: boolean }, addOns?: Array<{ __typename?: 'PlanAddOn', id: string, modifier?: string | null }> | null } | null, trial: { __typename?: 'SubscriptionTrial', isActive: boolean, promotionExpiresAt?: string | null }, addOns?: Array<{ __typename?: 'AddOn', cost: number, id: string, increment: number, modifier: string, quantity: number }> | null, limitedResources?: { __typename?: 'LimitedResources', archivedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, mountedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, projects?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, storageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null, workspaces?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null } | null, perUserStorage?: { __typename?: 'AccountSubscriptionPerUserStorage', seats: number, increment: number, limit: number } | null }, usageByLicenseType: { __typename?: 'SeatUsageByLicenseTypeMapping', member?: { __typename?: 'SeatUsage', activeSeatsUsed: number, availableSeats?: number | null, isHardLimit: boolean, pendingSeatsUsed: number, overSeatLimit: boolean, seatLimit?: number | null, seatsUsed: number } | null, guest?: { __typename?: 'SeatUsage', activeSeatsUsed: number, availableSeats?: number | null, isHardLimit: boolean, pendingSeatsUsed: number, overSeatLimit: boolean, seatLimit?: number | null, seatsUsed: number } | null, reviewer?: { __typename?: 'SeatUsage', activeSeatsUsed: number, availableSeats?: number | null, isHardLimit: boolean, pendingSeatsUsed: number, overSeatLimit: boolean, seatLimit?: number | null, seatsUsed: number } | null }, role?: { __typename?: 'Role', id: string, name: string } | null } | null };


export const GetAccountUsage = /*#__PURE__*/ gql`
    query GetAccountUsage($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountPlanAndTrialInfo
    ...AccountLockingInfo
    ...AccountRoleInfo
    id
    delinquentGracePeriodExpiresAt
    managedBy
    owner {
      id
      name
      email
    }
    subscription {
      ...SubscriptionInfo
    }
    usageByLicenseType {
      member {
        activeSeatsUsed
        availableSeats
        isHardLimit
        pendingSeatsUsed
        overSeatLimit
        seatLimit
        seatsUsed
      }
      guest {
        activeSeatsUsed
        availableSeats
        isHardLimit
        pendingSeatsUsed
        overSeatLimit
        seatLimit
        seatsUsed
      }
      reviewer {
        activeSeatsUsed
        availableSeats
        isHardLimit
        pendingSeatsUsed
        overSeatLimit
        seatLimit
        seatsUsed
      }
    }
  }
}
    ${AccountPlanAndTrialInfo}
${AccountLockingInfo}
${AccountRoleInfo}
${SubscriptionInfo}` as unknown as DocumentNode<GetAccountUsageQuery, GetAccountUsageQueryVariables>;

          

          export const useGetAccountUsageQuery = (options?:QueryHookOptions<GetAccountUsageQuery, GetAccountUsageQueryVariables>) => useQuery(GetAccountUsage, options);

          

          export type GetAccountUsageQueryOptions = QueryHookOptions<GetAccountUsageQuery, GetAccountUsageQueryVariables>;

          

          export const useGetAccountUsageLazyQuery = (options?:LazyQueryHookOptions<GetAccountUsageQuery, GetAccountUsageQueryVariables>) => useLazyQuery(GetAccountUsage, options);

          

          export type GetAccountUsageQueryResult = ReturnType<typeof useGetAccountUsageQuery>;

          
